module.exports = __webpack_public_path__ + "636f3f03ad5082a99531b4c32980fc54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/construction-background.jpg
// module id = ./src/assets/construction-background.jpg
// module chunks = 0